/* drl-sticky-atc.js — sticky bar reveal + variant picking via two surfaces:
   desktop inline <select>s and a mobile bottom sheet of pill buttons. Both
   resolve the matching variant and write it to the shared [name="id"] input;
   the add/confirm buttons are real submit buttons associated to the product
   form, so Dawn's product-form.js runs the add. No add-to-cart JS of our own. */
(function () {
  function init(root) {
    var bar = (root || document).querySelector('[data-drl-satc]');
    if (!bar || bar.dataset.drlSatcBound) return;
    bar.dataset.drlSatcBound = '1';

    // Klaviyo's teaser docks to bottom:0 at z-index 90000 and lands on this
    // bar. Marking the document lets drl-sticky-atc.css suppress the teaser on
    // THIS page only — everywhere else it keeps working.
    document.documentElement.classList.add('drl-has-satc');

    var form = document.getElementById('product-form-' + bar.dataset.sectionId);
    var idInput = form && form.querySelector('input[name="id"]');

    var DATA = { variants: [], current: '' };
    var dataEl = bar.querySelector('[data-drl-satc-data]');
    if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) {} }
    var byId = {};
    DATA.variants.forEach(function (v) { byId[v.id] = v; });

    var priceEl = bar.querySelector('[data-drl-satc-price]');
    var compareEl = bar.querySelector('[data-drl-satc-compare]');
    var chipEl = bar.querySelector('[data-drl-satc-variant]');
    var addBtn = bar.querySelector('[data-drl-satc-add]');
    var selects = Array.prototype.slice.call(bar.querySelectorAll('.drl-satc__select'));
    var pills = Array.prototype.slice.call(bar.querySelectorAll('.drl-satc-pill'));

    var sheet = bar.querySelector('[data-drl-satc-sheet]');
    var panel = sheet && sheet.querySelector('.drl-satc-sheet__panel');
    var sPrice = bar.querySelector('[data-drl-satc-sheet-price]');
    var sCompare = bar.querySelector('[data-drl-satc-sheet-compare]');
    var sSave = bar.querySelector('[data-drl-satc-sheet-save]');
    var sTotal = bar.querySelector('[data-drl-satc-sheet-total]');
    var confirmBtn = bar.querySelector('[data-drl-satc-confirm]');
    var imgEls = Array.prototype.slice.call(bar.querySelectorAll('.drl-satc__img, .drl-satc-sheet__img'));

    // available in context = some available variant matches `val` on axis oi
    // and matches v on every other axis.
    function ok(oi, val, v) {
      return DATA.variants.some(function (x) {
        return x.available && x.opts[oi] === val &&
          x.opts.every(function (o, i) { return i === oi || o === v.opts[i]; });
      });
    }

    function paint(v) {
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) { compareEl.textContent = v.compare; compareEl.hidden = !v.compare; }
      if (chipEl) chipEl.textContent = v.label;
      if (addBtn) addBtn.disabled = !v.available;
      selects.forEach(function (sel) {
        var oi = +sel.dataset.opt;
        sel.value = v.opts[oi];
        Array.prototype.forEach.call(sel.options, function (o) { o.disabled = !ok(oi, o.value, v); });
      });
      pills.forEach(function (p) {
        var oi = +p.dataset.opt;
        p.setAttribute('aria-pressed', v.opts[oi] === p.dataset.val ? 'true' : 'false');
        p.disabled = !ok(oi, p.dataset.val, v);
      });
      if (sPrice) sPrice.textContent = v.price;
      if (sCompare) { sCompare.textContent = v.compare; sCompare.hidden = !v.compare; }
      if (sSave) { sSave.textContent = 'Spórolj ' + v.save; sSave.hidden = !v.save; }
      if (sTotal) sTotal.textContent = v.price;
      if (confirmBtn) confirmBtn.disabled = !v.available;
      // A kép a színt viszi. Ugyanaz az URL 224px-en mindkét dobozra elég:
      // a sávban 44, a lapon 56 CSS-pixel, tehát 4x illetve 4x fölött van.
      if (v.img) {
        imgEls.forEach(function (img) {
          if (img.getAttribute('src') === v.img) return;
          img.src = v.img;
        });
      }
    }

    function syncFromInput() { var v = byId[idInput && idInput.value]; if (v) paint(v); }

    function apply(v) {
      if (!v || !idInput) return;
      if (idInput.value !== v.id) {
        idInput.value = v.id;
        idInput.removeAttribute('disabled');
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else { paint(v); }
    }

    function pick(oi, val) {
      var cur = byId[idInput && idInput.value] || byId[DATA.current] || DATA.variants[0];
      var opts = cur ? cur.opts.slice() : [];
      opts[oi] = val;
      var v = DATA.variants.filter(function (x) { return x.opts.every(function (o, i) { return o === opts[i]; }); })[0] ||
        DATA.variants.filter(function (x) { return x.opts[oi] === val && x.available; })[0] ||
        DATA.variants.filter(function (x) { return x.opts[oi] === val; })[0];
      apply(v);
    }

    selects.forEach(function (s) { s.addEventListener('change', function () { pick(+s.dataset.opt, s.value); }); });
    pills.forEach(function (p) { p.addEventListener('click', function () { pick(+p.dataset.opt, p.dataset.val); }); });

    // ---- sheet open/close (mobile only) ----
    var opener = bar.querySelector('[data-drl-satc-open]');
    var prevOverflow = '';
    var mqDesktop = window.matchMedia('(min-width: 750px)');

    function open() {
      if (!sheet || mqDesktop.matches || sheet.classList.contains('is-open')) return;
      sheet.hidden = false;
      void sheet.offsetWidth;
      sheet.classList.add('is-open');
      // Csak a sajat zarat orizzuk: egy orokolt `hidden`-t nem irunk vissza
      // bezaraskor, mert az veglegesen zarva hagyna a lapot.
      prevOverflow = document.documentElement.style.overflow;
      if (prevOverflow === 'hidden') prevOverflow = '';
      document.documentElement.style.overflow = 'hidden';
      var first = sheet.querySelector('.drl-satc-pill:not([disabled])') || sheet.querySelector('.drl-satc-sheet__close');
      if (first) first.focus();
    }
    function close() {
      if (!sheet) return;
      sheet.classList.remove('is-open');
      document.documentElement.style.overflow = prevOverflow;
      setTimeout(function () { sheet.hidden = true; }, 320);
      if (opener && opener.focus) opener.focus();
    }
    ['[data-drl-satc-open]', '[data-drl-satc-openzone]'].forEach(function (s) {
      var el = bar.querySelector(s); if (el) el.addEventListener('click', open);
    });
    sheet && sheet.querySelectorAll('[data-drl-satc-close]').forEach(function (el) { el.addEventListener('click', close); });
    if (confirmBtn) confirmBtn.addEventListener('click', function () { setTimeout(close, 0); });
    if (panel) {
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        var f = panel.querySelectorAll('button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    // ---- promo tab -> Klaviyo form ----
    // openForm is Klaviyo's onsite API; we only replaced the teaser, the form
    // itself still comes from the app embed.
    var promo = bar.querySelector('[data-drl-satc-promo]');
    if (promo) {
      var claimed = false;
      try { claimed = localStorage.getItem('drlSatcPromo') === 'done'; } catch (err) {}
      promo.hidden = claimed;
      // Klaviyo freezes the page with body.klaviyo-prevent-body-scrolling while
      // a form is up. Opened through openForm it does not always take the lock
      // off again — measured 2026-08-27: the class survived the close and the
      // page stayed frozen. So we watch the form ourselves and release it once
      // it is gone. Bounded at 5 minutes; no interval outlives the visit.
      var klWatch = null;
      function klFormUp() {
        var p = document.querySelector('[data-testid="POPUP"]');
        if (!p) return false;
        var r = p.getBoundingClientRect();
        return r.width > 20 && r.height > 20;
      }
      promo.addEventListener('click', function () {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', promo.dataset.form]);
        clearInterval(klWatch);
        var tries = 0;
        var seen = false;
        klWatch = setInterval(function () {
          if (++tries > 600) { clearInterval(klWatch); return; }
          if (klFormUp()) { seen = true; return; }
          if (!seen) return;
          document.body.classList.remove('klaviyo-prevent-body-scrolling');
          clearInterval(klWatch);
        }, 500);
      });
      // Someone who already took the discount should not be offered it again.
      window.addEventListener('klaviyoForms', function (evt) {
        var t = evt.detail && evt.detail.type;
        if (t !== 'submit' && t !== 'redeemedOffer') return;
        promo.hidden = true;
        try { localStorage.setItem('drlSatcPromo', 'done'); } catch (err) {}
      });
    }

    // ---- reveal + initial paint ----
    bar.hidden = false;
    syncFromInput();
    if (idInput) idInput.addEventListener('change', syncFromInput);

    // Reveal modes (data-reveal) — a fő Kosárba gomb élő helyzetéből számolva,
    // rAF-fal fojtott passzív görgetés-figyelővel (az IntersectionObserver
    // gyors görgetésnél átugorhat egy keresztezést):
    //   always       — MINDIG látszik, a vásárlódobozon is. Ez az alap.
    //                  Azért, mert az ajánlatkártyáknál a lapon SEHOL nincs
    //                  kint az ár: a kártya ára a hajtás alatt van, a fő ár
    //                  blokkot pedig a kártyák elrejtik. A sáv az egyetlen
    //                  felület, ami a döntés pillanatában árat mutat.
    //   after_atc    — csak amikor a fő Kosárba gomb nincs a képen (a 2026-08-27
    //                  előtti „always").
    //   after_buybox — csak miután EL is görgettünk mellette.
    //   delay        — a hős fölött rejtve, utána mint az after_atc.
    var reveal = bar.dataset.reveal || 'always';
    var armed = reveal !== 'delay';
    var watchEl = document.querySelector(bar.dataset.watch || '');
    if (reveal === 'always') {
      bar.classList.add('drl-satc--shown');
    } else if (watchEl) {
      var ticking = false;
      var compute = function () {
        ticking = false;
        var r = watchEl.getBoundingClientRect();
        var visible = r.bottom > 0 && r.top < window.innerHeight;
        var past = r.bottom <= 0; // scrolled above the viewport
        if (!armed && (visible || past)) armed = true;
        var show;
        if (reveal === 'after_buybox') show = !visible && past;
        else if (reveal === 'delay') show = armed && !visible;
        else show = !visible; // after_atc

        bar.classList.toggle('drl-satc--shown', show);
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(compute); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      compute();
    } else {
      bar.classList.add('drl-satc--shown');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
